import * as React from 'react';

import { useContainerWidth } from './useContainerWidth';

const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
};

/**
 * Checks whether a particular Tailwind CSS breakpoint size applies to a container element.
 *
 * @param ref The ref to the container element to measure.
 * @param size The size to check.
 *
 * @returns A boolean indicating whether the container width meets or exceeds the breakpoint.
 */
export const useContainerBreakpoint = <T extends Element>(
  ref: React.RefObject<T | null | undefined>,
  size: 'sm' | 'md' | 'lg' | 'xl' | '2xl'
) => {
  const { containerWidth } = useContainerWidth(ref);

  return React.useMemo(() => containerWidth >= breakpoints[size], [containerWidth, size]);
};
